"use client";

import {
  Button,
  makeStyles,
  MessageBar,
  Text,
} from "@fluentui/react-components";
import { getErrorMessage, type FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { VsaApiError } from "../../models/ClientError";
import { SkanskaColorTokens } from "../../style/colors";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: "16px",
  },
  header: {
    color: SkanskaColorTokens.color_action_red,
    textWrap: "balance",
  },
  button: {
    maxWidth: "200px",
    marginLeft: "auto",
  },
});

function ErrorFallbackApp({ error }: FallbackProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  let apiError: VsaApiError | undefined = undefined;
  const errorMessage = getErrorMessage(error) ?? t("someError");

  // Try with empty catch since non API errors will fail here
  // This is to get the api errors typed.
  try {
    apiError = JSON.parse(errorMessage);
  } catch {
    /* empty */
  }

  return (
    <MessageBar intent={"error"}>
      <div className={classes.root}>
        <h1 className={classes.header}> {t("applicationError")} </h1>
        <Text>{t("reloadOrTryAgain")}</Text>
        <Text>{apiError ? apiError.message : errorMessage}</Text>
        {apiError && apiError.correlationId && (
          <Text>
            {t("correlationIdLabel")}
            {apiError.correlationId}
          </Text>
        )}
        {apiError && apiError.stackTrace && (
          <>
            <br />
            <Text>{apiError.stackTrace}</Text>
          </>
        )}

        <Button
          className={classes.button}
          appearance="primary"
          onClick={() => window.location.reload()}
        >
          {t("reloadPage")}
        </Button>
      </div>
    </MessageBar>
  );
}

export default ErrorFallbackApp;
